"use client";

import { Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FeaturedRoaster() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  return <section className="bg-dark-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <Card className="grid grid-cols-1 lg:grid-cols-5 gap-0 overflow-hidden bg-dark-background/70 border border-border/20 shadow-strong p-0">
          {}
          <div ref={imageRef} className="lg:col-span-2 relative overflow-hidden group">
            <div className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${imageVisible ? "translate-x-0 opacity-100" : "-translate-x-8 opacity-0"}`}>
              <img src="https://bestcoffeecanada.com/wp-content/uploads/2025/11/Logo-2024-Gold-Star-Coffee-Square-with-Border-scaled.png" alt="Gold Star Coffee Premium Roast" className="w-full h-full object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-spring)] group-hover:scale-110" />
            </div>
          </div>

          {}
          <Separator orientation="vertical" className="hidden lg:block bg-border/30 shadow-[0_0_8px_rgba(0,0,0,0.3)]" />

          {}
          <div ref={contentRef} className="lg:col-span-3 flex flex-col justify-center gap-6 p-8 lg:p-12">
            {}
            <div className={`transition-all duration-[var(--duration-medium)] delay-100 ease-[var(--ease-smooth)] ${contentVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
              <div className="inline-flex items-center gap-3 bg-accent/10 border border-accent/30 rounded-lg px-4 py-3 shadow-soft">
                <div className="flex items-center gap-1">
                  <Star className="size-5 fill-accent text-accent" />
                  <Star className="size-5 fill-accent text-accent" />
                  <Star className="size-5 fill-accent text-accent" />
                  <Star className="size-5 fill-accent text-accent" />
                  <Star className="size-5 fill-accent text-accent" />
                </div>
                <span className="text-foreground-dark font-semibold text-lg">
                  5.0
                </span>
                <span className="text-muted-dark-background text-sm">
                  (248 reviews)
                </span>
              </div>
            </div>

            {}
            <div className={`transition-all duration-[var(--duration-medium)] delay-200 ease-[var(--ease-smooth)] ${contentVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
              <h2 className="font-display text-3xl lg:text-4xl font-bold text-foreground-dark mb-2">
                Gold Star Coffee
              </h2>
              <p className="text-accent text-sm font-medium uppercase tracking-wide">
                Top Rated Specialty Roaster
              </p>
            </div>

            {}
            <div className={`transition-all duration-[var(--duration-medium)] delay-300 ease-[var(--ease-smooth)] ${contentVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
              <h3 className="font-display text-lg font-semibold text-foreground-dark mb-3">
                Featured Roaster
              </h3>
              <p className="text-muted-dark-background leading-relaxed">
                Gold Star Coffee - World's Best Tasting Coffee® Fire Roasts and Hand Crafts all of their coffees with a 100 year old roasting technique that simply makes the best tasting Specialty Gourmet Coffee.
              </p>
            </div>

            {}
            <div className={`transition-all duration-[var(--duration-medium)] delay-[400ms] ease-[var(--ease-smooth)] ${contentVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
              <Link to="/RoastersPage">
                <Button size="lg" className="group hover:-translate-y-1 hover:shadow-[0_8px_24px_rgba(217,142,56,0.3)] transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
                  Explore Gold Star Coffee
                  <span className="transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:translate-x-1">
                    →
                  </span>
                </Button>
              </Link>
            </div>
          </div>
        </Card>
      </div>
    </section>;
}